import { Text } from '@chakra-ui/core';
import { Table as ChakraTable } from '@chakra-ui/table';
import React from 'react';
import { Column, useSortBy, useTable } from 'react-table';
import { TableBody } from './table/TableBody';
import { TableHead } from './table/TableHead';

export const EmptyPlaceholder = (): JSX.Element => (
  <Text display="block" width="100%" textAlign="center" fontSize="13px" color="gray.400">
    ---
  </Text>
);

// eslint-disable-next-line @typescript-eslint/ban-types
export interface GenericDataTableProps<Data extends object> {
  data: Data[];
  columns: Column<Data>[];
  isLoading?: boolean;
  onRowClick?: (row: Data) => void;
  getRowBgColor?: (row: Data, index: number) => string | undefined;
  getCellBgColor?: (row: Data, columnId: string) => string | undefined;
  getCellProps?: (row: Data, columnId: string, index: number) => Record<string, unknown>;
}

// eslint-disable-next-line @typescript-eslint/ban-types
export function GenericDataTable<Data extends object>({
  data,
  columns,
  isLoading = false,
  onRowClick,
  getRowBgColor,
  getCellBgColor,
  getCellProps,
}: GenericDataTableProps<Data>): JSX.Element {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({ columns, data }, useSortBy);
  return (
    <ChakraTable {...getTableProps()} style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
      <TableHead headerGroups={headerGroups} />
      <TableBody
        rows={rows}
        prepareRow={prepareRow}
        getTableBodyProps={getTableBodyProps}
        columnCount={columns.length}
        isLoading={isLoading}
        onRowClick={onRowClick}
        getRowBgColor={getRowBgColor}
        getCellBgColor={getCellBgColor}
        getCellProps={getCellProps}
      />
    </ChakraTable>
  );
}
